// DMA 平均差   DMA只是以收盘价（CLOSE）作为唯一的数据源，进行平均算数。
// DIF:MA(CLOSE,N1)-MA(CLOSE,N2);
// 输出DIF:收盘价的N1日简单移动平均-收盘价的N2日简单移动平均；
// DIFMA:MA(DIF,M); 输出均线DIF:DIF的M日简单移动平均；
// 默认参数：N1=10，N2=50，M=10

import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
import el from "element-ui/src/locale/lang/el";
const model = {
    dif: {
        Type: Array,
        Default: () => ([])
    },
    difma: {
        Type: Array,
        Default: () => ([])
    },
    params: {
        type: String,
        Default: '(10,50,10)'
    }
}
export default class DMAState extends FootDectorator(BaseContext) {
    constructor({ data, ...rest }) {
        super({ ...rest, data: mergeModelData(model, data)})
    }

    // 计算y轴数值范围
    _calcRange() {
        let { dif, difma, code ,params} = this.state.data
        let { maxValue, minValue } = this.calcRange({ data: [dif, difma], targetKey: 'value', isAdditional: true })
        // if (maxValue === minValue) {
        //   if (maxValue === 0) {
        //     maxValue = 1;
        //     minValue = -1;
        //   } else if (maxValue === 100) {
        //     maxValue = 150;
        //     minValue = 50;
        //   }
        // } else {
        //   const ratioVal = maxValue * 0.05;
        //   maxValue += ratioVal;
        //   minValue -= ratioVal;
        // }
        this.maxValue = maxValue;
        this.minValue = minValue;
    }

    // 计算坐标
    _calcAxis() {
        const maxValue = this.maxValue;
        const range = maxValue * 2;
        const {
            height
        } = this.availArea;
        const radio = height / range;
        const { dif, difma, start, end } = this.state.data;
        const curryCalcAxis = curryFun(this.calcAxis, this, {
            targetKey: 'value',
            sourceKey: 'lineY',
            isAdditional: true,
        });
        curryCalcAxis({ data: dif });
        curryCalcAxis({ data: difma });
    }
    // 画主图
    _drawMain() {
        const {
            left,
            width,
            height,
            top,
            bottom
        } = this.availArea;
        const middleY = top + height / 2;
        const { dif, difma } = this.state.data;
        this._drawBar(left, middleY, width);
        const { LINE } = LINE_TYPE;
        const { dif: difLine, difma: difmaLine } = this.option.Dma
        this._drawLine(LINE, dif, left, bottom, difLine.lineWidth, difLine.color);
        this._drawLine(LINE, difma, left, bottom, difmaLine.lineWidth, difmaLine.color);
    }
    _drawAxisY() {
        const { axisY } = this.option.Dma;
        const {
            left,
            right,
            top,
            bottom,
            height,
        } = this.availArea;
        const ctx = this.context;
        const maxValue=this.maxValue
        const minValue=this.minValue
        let line;
        if(maxValue>0&&minValue<0){
          line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
        }else if(maxValue<0&&minValue<0) {
          line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
        }else {
          line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
        }
        ctx.beginPath();
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        // fillStyle 方法
        ctx.fillStyle = axisY.color;
        ctx.font = axisY.sizeRatio * this.state.baseSize * this.dpr + "px " + axisY.fontFamily;
        ctx.fillText(maxValue.toFixed(2), left, top+20);
        ctx.textBaseline = 'middle';
        ctx.fillText(line, left, top + height / 2);
        ctx.textBaseline = 'bottom';
        ctx.fillText(minValue.toFixed(2), left, bottom);
    }
    // @checkFootTitleAuth
    _drawTitle() {
        const ctx2 = this.curContext;
        const { top } = this.availArea;
        const { current, sealObj } = this.state.data;
        const { height, baseSize } = this.state;
        const { ratioFixed } = sealObj;
        const { space } = this.option.Dma
        const { baseLine } = this.option.FootContext.title;
        const baseLineY = top + height * baseLine;
        let { left,right } = this.availArea;
        // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
        const {
            sizeRatio,
            fontFamily,
            axisY,
        } = this.option.Dma;
        [
            'params',
            'dif',
            'difma',
        ].forEach(val => {
            const data = this.state.data[val]
            if(data=='DMA(10,50,10)'){
                let color = this.option.Dma.params.color
                ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                ctx2.fillStyle = color;
                ctx2.textAlign = 'left';
                ctx2.textBaseline = 'top';
                ctx2.beginPath();
                const text = data
                const textWidth = ctx2.measureText(text).width;
                ctx2.fillText(text, left, baseLineY,right);
                left += textWidth+10 ;

            }else{
            if (Util.isArray(data)) {
                let color = this.option.Dma[val].color
                const item = data[current];
                ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                ctx2.fillStyle = color;
                ctx2.textAlign = 'left'
                ctx2.textBaseline = 'top';
                ctx2.beginPath();
                if (Util.isDef(item) && Util.isValidNumber(item.value)) {
                    // 吧字符串转换为大写
                    const text = val.toUpperCase() + ':' + item.value.toFixed(ratioFixed);
                    const textWidth = ctx2.measureText(text).width
                    ctx2.fillText(text, left, baseLineY);
                    left += textWidth

                } else {
                    const text = val.toUpperCase() + ': -';
                    const textWidth = ctx2.measureText(text).width;
                    ctx2.fillText(text, left, baseLineY);
                    left += textWidth;
                }
                left+=space*this.dpr
            }
        }
        })
    }
}

